import { createAction, createReducer } from 'deox';

export interface DriversLicense {
  result: 'success' | 'error' | 'existingAccount' | null;
}

export interface DriversLicenseState {
  entity: DriversLicense;
  /**
   * Unrecoverable error from the MWB SDK. Once this, startScanning
   * cannot be called again without causing an error.
   */
  scanError: boolean;
}

export const defaultState: DriversLicenseState = {
  entity: { result: null },
  scanError: false,
};

export const mergeDriversLicense = createAction(
  'MERGE_DRIVERS_LICENSE',
  resolve => (data: Partial<DriversLicense>) => resolve(data),
);

export const setScanError = createAction(
  'SET_SCAN_ERROR',
  resolve => (scanError: boolean) => resolve(scanError),
);

export const driversLicenseReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(mergeDriversLicense, (state, { payload: data }) => {
      return {
        ...state,
        entity: {
          ...state.entity,
          ...data,
        },
      };
    }),
    handleAction(setScanError, (state, { payload: scanError }) => ({
      ...state,
      scanError: scanError,
    })),
  ],
);

export interface MountedState {
  driversLicense: ReturnType<typeof driversLicenseReducer>;
}

export const selectDriversLicense = (state: MountedState): DriversLicense =>
  state.driversLicense.entity;

export const selectScanError = (state: MountedState): boolean =>
  state.driversLicense.scanError;

export default driversLicenseReducer;
